module.exports = __webpack_public_path__ + "kh.1543a39f5fd92fd0f32d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/kh.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/kh.svg
// module chunks = styles